import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/traveling-for-treatment")({
  beforeLoad: () => {
    throw redirect({
      to: "/learn/$slug",
      params: { slug: "travel-for-saint-tms" },
      replace: true,
    });
  },
});
